import { useEffect, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { CheckIcon } from "@heroicons/react/24/outline";

import { ControlledDropdown } from "shared/ui";
import { clsxMerge } from "shared/lib/helpers";
import { ContactDetailI } from "@/interfaces/accounts";

export const AddUserToListsLSidebarLeadsDropdown = ({
  items,
  onUpdate = () => {},
  disabled,
}: {
  items?: ContactDetailI[];
  onUpdate?: (selectedItem: ContactDetailI | null) => void;
  disabled?: boolean;
}) => {
  const [selectedItem, setSelectedItem] = useState<ContactDetailI | null>(
    items?.[0] || null
  );

  const dropdownLabel = selectedItem
    ? `${selectedItem.first_name} ${selectedItem.last_name}`
    : "Select lead";

  const handleListChange = (item: ContactDetailI) => {
    if (item === selectedItem) {
      setSelectedItem(null);
    } else {
      setSelectedItem(item);
    }
  };

  useEffect(() => {
    onUpdate(selectedItem);
  }, [selectedItem]);

  return (
    <ControlledDropdown
      className={clsxMerge("dropdown-end w-full", {
        "disabled cursor-not-allowed opacity-60": disabled,
      })}
      closeOnContentClick
    >
      {() => (
        <>
          <label
            tabIndex={0}
            title={dropdownLabel}
            className="mr-1 block w-full text-start text-black/40"
          >
            <div
              className={clsxMerge(
                "flex justify-between",
                "b-typography-body3 truncate text-black/60",
                "rounded-lg border-2 bg-white",
                "w-full p-4"
              )}
            >
              {dropdownLabel}
              <ChevronDownIcon className="w-4" />
            </div>
          </label>

          <div
            tabIndex={0}
            className="dropdown-content menu w-full rounded-lg bg-base-100 shadow-lg"
          >
            {items?.map((item, i) => (
              <label
                key={i}
                className={clsxMerge(
                  "label cursor-pointer hover:bg-black/5",
                  "w-full p-4",
                  "ae-typography-body2 label-text"
                )}
                onClick={() => handleListChange(item)}
              >
                <span className="flex">
                  {`${item.first_name} ${item.last_name}`}
                </span>

                {selectedItem === item && <CheckIcon className="w-4" />}
              </label>
            ))}
          </div>
        </>
      )}
    </ControlledDropdown>
  );
};
